import React, { PureComponent } from 'react';
import { Button } from '../../atoms/Button';
import { words } from '../../../constants';
import { LoadingIndicator } from '../../atoms/LoadingIndicator';
import { ContactInfoBanner } from '../../organisms/ContactInfoBanner';
import {
  Container,
  ContentWrapper,
  ErrorMessage,
  ButtonWrapper,
  LoadingWrapper,
} from './elements';

type Props = {
  err: string;
  backToLogin: () => void;
  onClickMail: () => void;
};

class URLInvalidMsg extends PureComponent<Props> {
  render = (): React.ReactElement => {
    const { backToLogin, onClickMail, err } = this.props;
    if (err) {
      return (
        <Container>
          <ContentWrapper>
            <ContentWrapper>
              <ErrorMessage>{words.urlAuthenticated}</ErrorMessage>
              <ErrorMessage>{words.backToLoginPage}</ErrorMessage>
            </ContentWrapper>
            <ButtonWrapper>
              <Button
                onPress={backToLogin}
                title={words.gotoLogin}
                fontWeight="700"
                theme="primary"
                textSize="16px"
              />
            </ButtonWrapper>
          </ContentWrapper>

          <ContactInfoBanner onClickMail={onClickMail} />
        </Container>
      );
    } else {
      return (
        <LoadingWrapper>
          <LoadingIndicator />
        </LoadingWrapper>
      );
    }
  };
}

export default URLInvalidMsg;
